import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { createRole, updateRole } from "../services/roleApi";
import { useQueryClient } from "react-query";
import toast from "react-hot-toast";
import { Row, Spin } from "antd";
import { SettingOutlined } from "@ant-design/icons";
import "../../Styles/style.css"
import FormField from "../../../Components/Common/Form/FormField";

const AddEditRoleForm = ({ modal, setModal, toggle, selectedRole }) => {
  
  const queryClient = useQueryClient();
  const [isLoading, setIsLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Mais il te faut un nom pour créer un role"),
    description: Yup.string().required("Merci de mettre la description"),
  });

  const initialValues = selectedRole ? {
    name: selectedRole.name,
    description: selectedRole.description,
  } : {
    name: "",
    description: "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        
        if (selectedRole) {
          await updateRole(selectedRole?.id, {...values});
          toast.success("Le role a été modifié avec succès 🎉");
        } else {
          await createRole({...values});
          toast.success("Le role a été créé avec succès 🎉");
        }

        await queryClient.invalidateQueries("roles");
        toggle();
        formik.resetForm();
      } catch (error) {
        toast.error(`😌 Erreur: ${error?.message || error}`);
      } finally {
        setIsLoading(false);
      }
    },
  });

  useEffect(() => {
    formik.setValues(initialValues);
  }, [selectedRole]);

  const modalTitle = selectedRole ? "Édition" : `Ajout`;

  return (
    <Modal
      id="showModalClient"
      isOpen={modal}
      toggle={toggle}
      centered
      backdrop={"static"}
      style={{ maxWidth: "700px" }}
    >
      <ModalHeader className="bg-info-subtle p-3" toggle={toggle}>
        {modalTitle} d'un role <SettingOutlined />
      </ModalHeader>
      <Form onSubmit={formik.handleSubmit}>
        <ModalBody>
          <Row>
            <FormField label="Nom" name="name" formik={formik} colSize={12} placeholder="Entrez le nom du role"/>
            <FormField label="Description" name="description" formik={formik} colSize={12} placeholder="Entrez la description du role" isTextarea={true}/>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="light" onClick={() => setModal(false)}>
            Annuler
          </Button>
          <Button type="submit" className="btn btn-soft-success" disabled={isLoading}>
            {isLoading ? <Spin size="small" /> : (selectedRole ? "Modifier" : "Ajouter")}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default AddEditRoleForm;
